const button = "_35sbnsbj4e";
const stateBox = "_35ssvwe0i";

export { button, stateBox };
import "./input.character.style.linaria.module.css";
//# sourceMappingURL=input.character.style.js.map
